import gql from 'graphql-tag'

export const ITEM_TILE_FRAGMENT = gql`
fragment ItemTileFragment on Item {
  id
  name
  price
  orgPrice
  soldOut
  usingPepperService
  maxCommissionRate
  reviewRate
  reviewCount
  isLiked
  isActive
  display
  brand {
    id
    name
  }
  medias {
    id
    path
  }
  seller {
    id
    shop {
      id
      shoppingMallName
      status
    }
  }
  timeSaleInfo {
    id
    startedAt
    expiredAt
  }
}`
